import styled from "styled-components";

const Text = styled.p`
  font-family: "Raleway", sans-serif;
  font-size: 1.5em;
  max-width: 75vw;
`;

export default Text;
